import * as React from 'react';
import Page from 'components/Page';
import { Button, Row, Col, Input, Label, FormGroup } from 'reactstrap';
//import bgimage from '../assets/img/icon/ms-excel.png';
//import ReactExport from "react-data-export";
import { connect } from 'react-redux';
import { NumberWidget } from 'components/Widget';
import * as loginSelectors from 'store/login/reducer';
import PaginateTable from '../components/PaginateTable';
import InfoModal from '../components/InfoModal';
import BaseService from '../services/BaseService';
//import BaseService from '../services/BaseService';

/* const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet; */
 
class HistoryTransation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            date_from: this.returnDate(),
            date_to: this.returnDate("to"),
            show_form: false,
            show_deleting: false,
            dateFrom: false,
            dateTo: false,
            columns: [
                { name: 'comprador', title: 'Comprador', getCellValue: row => (row.buyer ? row.buyer.email : 'Indisponivel') },
                { name: 'method', title: 'Método', getCellValue: row => (row.method ? row.method.name : 'Indisponivel') },
                { name: 'status', title: 'Status', getCellValue: row => (row.status ? row.status.name : 'Indisponivel') },
                { name: 'local_updated_at', title: 'Data' },
                { name: 'value', title: 'Valor' }
            ],
            exportData: [],
            reload: false,
            editingObj: null,
            delete_id: -1,
            total_credit: 0
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.editAction = this.editAction.bind(this);
        this.onReloded = this.onReloded.bind(this);
        this.onExcel = this.onExcel.bind(this);
        this.closed = this.closed.bind(this);
    }
    componentDidMount() {
        this.getTotalCredit();

    }
    closed(refresh){
        if(refresh){
            this.setState({ show_form : false, reload : !this.state.reload, editingObj : null} )
        }
        else{
            this.setState({ show_form : false, editingObj : null})
        }
    }
    onReloded() {
        this.getTotalCredit();
        this.setState({
            reload: !this.state.reload,
        });
    }
    getTotalCredit() {
        var date1 = this.state.date_from;
        var date2 = this.state.date_to;
        date1 = date1.replace("/", "-").replace("/", "-");
        date2 = date2.replace("/", "-").replace("/", "-");

        fetch(BaseService.ENDPOINT + "admin/statistics/orders-total?start_date=" + date1 + "&end_date=" + date2 +"&qtd=10&page=", {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                Authorization: 'Bearer ' + this.props.user.access_token
            })
        })
        .then(results => {
            return results.json();
        })
        .then(data => {
            if (data.return.code === 1) {
                this.setState({
                    total_credit: data.data.total_value
                })
            } else if (data.return.code > 300) {
                window.location = '/';
            }
        })
    }
    returnApi = () => {
        var date1 = this.state.date_from;
        var date2 = this.state.date_to;
        date1 = date1.replace("/", "-").replace("/", "-");
        date2 = date2.replace("/", "-").replace("/", "-");
        var date = "admin/statistics/orders?start_date=" + date1 + "&end_date=" + date2 +"&qtd=10&page=";
        return date
    }
    returnDate(type) {
        var da = new Date();
        var mounth = da.getMonth() + 1;
        var year = da.getFullYear();
        var data = new Date(year, mounth, 0);
        var day = data.getDate();
        if (da.getMonth() + 1 < 10) {
            mounth = "0" + (da.getMonth() + 1);
        }
        if (type === "to") {
            return year + "-" + mounth + "-" + day;
        } else {
            day = "01";
            return year + "-" + mounth + "-" + day;
        }
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value,
        });
    }
    onExcel(){
        window.open(BaseService.ENDPOINT + "orders-export?start_date="+this.state.date_from+"&end_date="+this.state.date_from+"&access_token="+this.props.user.access_token+"&", "_blank");  
    }
    editAction(idx, obj){
      this.setState({ show_form : true , editingObj : obj})
    }
    render() {
        return (
            <Page
                title="Historico de Transação"
                className="UserAdviserPage">
                <Row>
                    <Col sm={3}>
                        <Button 
                            outline 
                            onClick={this.onExcel}
                            style={{
                                marginTop: '7px'
                            }}
                        > Exportar para Excel</Button>
                    </Col>
                </Row>
                <Row>
                    <Col sm={3} >
                        <FormGroup>
                            <Label >De: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_from"
                                value={this.state.date_from}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateFrom}
                                max={this.state.date_to}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={3}   >
                        <FormGroup>
                            <Label>Até: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_to"
                                value={this.state.date_to}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateTo}
                                min={this.state.date_from}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={2}>
                    <br/>
                        <Button 
                            outline 
                            onClick={this.onReloded}
                            style={{
                                marginTop: '7px'
                            }}
                        > Procurar</Button>
                    </Col>
                    <Col sm={5} className="mb-3">
                        <NumberWidget
                            title={<h5>Total por período</h5>}
                            number={"R$ "+ parseFloat(this.state.total_credit).toFixed(2)}
                            color="primary"
                            hiddenProgress
                            progress={{
                                value: (this.state.total_credit === 0 ? 0 : 100)
                            }}
                        />
                    </Col>
                </Row>
                <InfoModal
                    visible={this.state.show_form}
                    editing={this.state.editingObj}
                    toggle={this.closed}
                />
                <PaginateTable
                    api={this.returnApi()}
                    route="true"
                    user={this.props.user}
                    columns={this.state.columns}
                    dateFilter="false"
                    integratedFilter="false"
                    currencyColumns="false"
                    showPagingState="false"
                    filterState="false"
                    hideButton={false}
                    integratePag="false"
                    editAction={this.editAction}
                    reload={this.state.reload}
                />
                
            </Page>
        );
    }
};


// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
    const currentUser = loginSelectors.getUser(state);
    return {
        user: currentUser
    };
}
export default connect(mapStateToProps)(HistoryTransation)


// WEBPACK FOOTER //
// ./src/pages/HistoryTransation.js